import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertComponent } from 'src/components/alert/alert.component';
import { PrintService } from 'src/services/print.service';

@Component({
  selector: 'app-show-label',
  templateUrl: './show-label.component.html',
  styleUrls: ['./show-label.component.css']
})
export class ShowLabelComponent implements OnInit {
  printCount: number = 1;

  labelImg: string = '';
  hri: any;
  labels: any[] = [];
  formats: any[];
  selectedFormat: string;

  constructor(
    private dialogRef: MatDialogRef<ShowLabelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private printService: PrintService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    // if (this.data) {
      // debugger
      this.labelImg = 'data:image/png;base64,' + this.data.record.label[0].code;
      this.hri = this.data.record.label[0].hri;
    // }
    this.loadFormats();
  }

  cancel() {
    this.dialogRef.close();
  }

  loadFormats() {
    this.printService.getPrintFormats().subscribe(
      (result: any)=> {
        this.formats = result['data'];
      });
  }

  print(format) {
    if (!format) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          note: "Please select a print format before printing",
        },
      });

      return;
    }
    if (this.labels.length > 0) {
      this.labels = [];
    }
    var obj = {
      img: this.labelImg,
      hri: this.hri
    };
    for (var i = 0; i < this.printCount; i++) {
      this.labels.push(obj);
    }
    var printWin = window.open('', 'new div', 'height=400,width=600');
    var htmlStr = this.printService.getHtmlStr(format, this.labels);

    console.log(htmlStr);

    printWin.document.write(htmlStr);
    printWin.print();
    // printWin.close();

    // this.dialogRef.close();
  }
}
